import theme from 'library/theme/theme';
import styled from 'styled-components';

export const Actions = styled.div`
  display: flex;
  gap: ${theme.spacing(2)};
  justify-content: flex-end;
  margin-top: ${theme.spacing(2)};
`;
